import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GeolocationService } from '../services/geolocation.service';

@Injectable({
  providedIn: 'root',
})
export class LocationInterceptor implements HttpInterceptor {
  constructor(private locationService: GeolocationService) {}

  private addLocationHeader(req: HttpRequest<any>, location: string): HttpRequest<any> {
    return req.clone({ setHeaders: { 'X-Location': location } });
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.endsWith('/checkout') || req.url.endsWith('/hold')) {
      const loc = this.locationService.location || { lat: 0, lng: 0 };
      return next.handle(this.addLocationHeader(req, `${loc.lat};${loc.lng}`));
    }

    return next.handle(req);
  }
}
